import { useCallback } from 'react';
import { authService } from '../services/authService';

export function useLoginWithAzure() {
  return useCallback(() => authService.loginWithAzure(), []);
}
